import { useEffect, useState } from "react";
import type { Run, RunId } from "@dayvise/domain";
import { useActiveWorkspaceId } from "./providers.tsx";

/** Selection is scoped to the view, while recovery comes from durable runs. */
export function useConversationRun(conversationId: string, branchId: string | null, runs: readonly Run[] = []) {
  const workspaceId = useActiveWorkspaceId();
  const key = `${workspaceId}:${conversationId}:${branchId}`;
  const [selection, setSelection] = useState<{ key: string; runId: RunId | null }>({ key, runId: null });
  const candidates = runs.filter((run) => run.conversationId === conversationId && (!branchId || run.branchId === branchId))
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const runId = (selection.key === key ? selection.runId : null) ?? candidates[0]?.runId ?? null;
  useEffect(() => {
    if (runId && (selection.key !== key || selection.runId === null)) setSelection({ key, runId });
  }, [key, runId, selection.key, selection.runId]);
  return { runId, runs: candidates, selectRun: (next: RunId | null) => setSelection({ key, runId: next }) };
}
